import { withNs } from "@/i18n/load";

export function pageRoute({
  path,
  name,
  component,
  section,
  bodyClass,
  title,
  titleKey,
  locales = [],
  ns,
  alias,
}) {
  const route = {
    path,
    name,
    component,
    beforeEnter: ns ? withNs(ns) : undefined,
    meta: {
      section,
      bodyClass,
      title,
      titleKey,
      locales,
    },
  };

  // ✅ only attach alias if it actually exists
  if (alias) {
    route.alias = alias;
  }

  return route;
}
